import { vinApi } from "@/lib/api/vin"

export async function decodeVIN(vin: string) {
  const result = await vinApi.searchByVin(vin)
  return {
    year: result.year ?? null,
    make: result.make ?? null,
    model: result.model ?? null,
    trim: result.trim ?? null,
    type: result.type ?? null,
  }
}
